/** URL (or file) of a library sound by id; the plain whoosh is the fallback for older props. */
export function sfxFor(id: string | null | undefined, sfxUrls?: Record<string, string>, sfxUrl?: string): string | undefined {
  if (!id) return undefined;
  return sfxUrls?.[id] ?? (id === "whoosh" ? sfxUrl : undefined);
}

/** Sounds at cuts and at placed moments sit a little under the opener's whoosh; each cue's own dB rides on top. */
export const CUE_SFX_GAIN = 0.12;
/** How long a cue's sequence runs: long enough for any library sound. */
export const CUE_FRAMES = 90;
/** A sound's level from the house gain and its own dB, never above unity. */
export const sfxLevel = (base: number, db: number): number => Math.min(1, base * Math.pow(10, db / 20));
